(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-rbs-gallery-src]');
    if (!button) return;
    const gallery = button.closest('[data-rbs-gallery]');
    const mainImage = gallery.querySelector('.rbs-product__main-image');
    mainImage.removeAttribute('srcset');
    mainImage.src = button.dataset.rbsGallerySrc;
    mainImage.alt = button.dataset.rbsGalleryAlt;
    gallery.querySelectorAll('[data-rbs-gallery-src]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-uv-decal"]) return;
  try {
    
  document.querySelectorAll('.rbs-uv-decal__form').forEach(form => {
    const quantity = form.querySelector('[name="quantity"]');
    const savedQuantity = Number(new URLSearchParams(location.search).get('quantity'));
    if (Number.isInteger(savedQuantity) && savedQuantity >= 1 && savedQuantity <= 999) quantity.value = String(savedQuantity);
    form.querySelector('[data-uv-variant]')?.addEventListener('change', event => {
      const url = new URL(location.href);
      url.searchParams.set('variant', event.target.value);
      url.searchParams.set('quantity', String(Math.max(1, Math.min(999, Math.trunc(Number(quantity.value) || 1)))));
      location.assign(url.href);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rbs-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const load = () => {
      if (document.querySelector('script[src="https://widgets.sociablekit.com/google-reviews/widget.js"]')) return;
      const script = document.createElement('script');
      script.src = 'https://widgets.sociablekit.com/google-reviews/widget.js';
      script.async = true;
      document.body.appendChild(script);
    };
    const root = document.querySelector('.rbs-reviews');
    if (!root) return;
    if (!('IntersectionObserver' in window)) { load(); return; }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { load(); observer.disconnect(); }
    }, { rootMargin: '400px' });
    observer.observe(root);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rbs-header"]) return;
  try {
    
  (() => {
    const selector = '.rbs-header__mobile, .rbs-header__categories';
    const openSelector = '.rbs-header__mobile[open], .rbs-header__categories[open]';
    const closeMenu = (menu, restoreFocus = false) => {
      menu.open = false;
      if (restoreFocus) menu.querySelector('summary').focus();
    };
    const closeOutside = (event) => {
      document.querySelectorAll(openSelector).forEach((menu) => {
        if (!menu.contains(event.target)) closeMenu(menu);
      });
    };
    const sizeMenu = (menu) => {
      const top = menu.closest('.rbs-header').getBoundingClientRect().bottom + 8;
      menu.style.setProperty('--rbs-menu-top', `${Math.max(0, top)}px`);
    };
    document.addEventListener('pointerdown', closeOutside);
    document.addEventListener('focusin', closeOutside);
    document.addEventListener('click', (event) => {
      closeOutside(event);
      const menu = event.target.closest(selector);
      if (!menu) return;
      if (event.target.closest('[data-rbs-menu-close]')) closeMenu(menu, true);
      else if (event.target.closest('a[href]')) closeMenu(menu);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll(openSelector).forEach((menu) => closeMenu(menu, true));
    });
    document.addEventListener('toggle', (event) => {
      if (event.target.matches('.rbs-header__mobile') && event.target.open) sizeMenu(event.target);
    }, true);
    window.addEventListener('resize', () => {
      document.querySelectorAll(openSelector).forEach((menu) => {
        if (menu.matches('.rbs-header__mobile')) {
          if (window.matchMedia('(min-width: 1181px)').matches) closeMenu(menu);
          else sizeMenu(menu);
        } else if (window.matchMedia('(max-width: 1180px)').matches) closeMenu(menu);
      });
    });
    window.addEventListener('pageshow', () => {
      document.querySelectorAll(openSelector).forEach((menu) => closeMenu(menu));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
